

// export default ProductDetail;
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChevronRight, 
  faChevronLeft, 
  faPlus, 
  faMinus, 
  faChevronDown, 
  faChevronUp 
} from '@fortawesome/free-solid-svg-icons';
// IMPORT THE MODULE HERE
// import styles from '../ProductDetails.module.css'; 
import Header from '../../headerFooter/header';
import HomeFooter from '../../homepage/homefooter';
import styles from  './ProductDetails.module.css'
const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [error, setError] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // CHANGED: State is now an array including both keys by default
  const [activeSections, setActiveSections] = useState(["desc", "specs"]);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch('/data/products.json')
      .then((res) => {
        if (!res.ok) throw new Error('Failed to fetch products');
        return res.json();
      })
      .then((data) => {
        const found = data.find((p) => p.id === parseInt(id));
        if (!found) throw new Error('Product not found');
        setProduct(found);
      })
      .catch((err) => setError(err.message));
  }, [id]);

  const handleBuyNow = () => {
    if (!product) return;
    navigate('/form', {
      state: {
        productName: product.name,
        price: product.discountPrice || product.price,
        quantity: quantity,
      },
    });
  };

  const handleImageNav = (direction) => {
    if (!product?.images) return;
    if (direction === 'next') {
      setCurrentImageIndex((prev) => (prev === product.images.length - 1 ? 0 : prev + 1));
    } else {
      setCurrentImageIndex((prev) => (prev === 0 ? product.images.length - 1 : prev - 1));
    }
  };

  // CHANGED: Logic to toggle items in/out of the array
  const toggleAccordion = (section) => {
    if (activeSections.includes(section)) {
      setActiveSections(activeSections.filter((s) => s !== section));
    } else {
      setActiveSections([...activeSections, section]);
    }
  };

  if (error) return <div style={{padding:'100px', textAlign:'center'}}>Error: {error}</div>;
  if (!product) return <div style={{padding:'100px', textAlign:'center'}}>Loading Details...</div>;

  // Helper to check if open
  const isDescOpen = activeSections.includes('desc');
  const isSpecsOpen = activeSections.includes('specs');
  const isShipOpen = activeSections.includes('ship');

  return (
    <div className={styles.wrapper}>
      <Header />
      
      <div className={styles.container}>
        
        {/* --- LEFT: IMAGE GALLERY --- */}
        <div className={styles.gallerySection}>
          <div className={styles.mainImageFrame}>
            <button className={`${styles.sliderBtn} ${styles.prevBtn}`} onClick={() => handleImageNav('prev')}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </button>
            
            <img 
              src={`/data/${product.images[currentImageIndex]}`} 
              alt={product.name} 
              className={styles.mainImg}
            />
            
            <button className={`${styles.sliderBtn} ${styles.nextBtn}`} onClick={() => handleImageNav('next')}>
              <FontAwesomeIcon icon={faChevronRight} />
            </button>
          </div>

          <div className={styles.thumbnailStrip}>
            {product.images.map((img, idx) => (
              <img
                key={idx}
                src={`/data/${img}`}
                alt="thumb"
                className={`${styles.thumbImg} ${idx === currentImageIndex ? styles.thumbActive : ''}`}
                onClick={() => setCurrentImageIndex(idx)}
              />
            ))}
          </div>
        </div>

        {/* --- RIGHT: INFO PANEL --- */}
        <div className={styles.infoSection}>
          <div>
            <h1 className={styles.productName}>{product.name}</h1>
            <p className={styles.shortDesc}>{product.shortDescription}</p>
          </div>

          <div className={styles.priceBlock}>
            {product.discountPrice ? (
              <>
                <span className={styles.finalPrice}>₹{product.discountPrice}</span>
                <span className={styles.oldPrice}>₹{product.price}</span>
              </>
            ) : (
              <span className={styles.finalPrice}>₹{product.price}</span>
            )}
          </div>

          <div className={styles.actionsRow}>
            <div className={styles.qtyWrapper}>
              <FontAwesomeIcon 
                icon={faMinus} 
                className={styles.qtyIcon}
                onClick={() => setQuantity(Math.max(1, quantity - 1))} 
              />
              <input type="text" readOnly value={quantity} className={styles.qtyInput} />
              <FontAwesomeIcon 
                icon={faPlus} 
                className={styles.qtyIcon}
                onClick={() => setQuantity(quantity + 1)} 
              />
            </div>
            <button className={styles.buyBtn} onClick={handleBuyNow}>
              Buy  &bull; ₹{(product.discountPrice || product.price) * quantity}
            </button>
          </div>

          {/* Accordions */}
          <div className={styles.accordionGroup}>
            
            {/* Description */}
            <div className={styles.accordionItem}>
              <button className={styles.accordionBtn} onClick={() => toggleAccordion('desc')}>
                Description
                <FontAwesomeIcon icon={isDescOpen ? faChevronUp : faChevronDown} />
              </button>
              {/* CHANGED: Check array includes 'desc' */}
              <div className={`${styles.accordionContent} ${isDescOpen ? styles.contentActive : ''}`}>
                <p>{product.description}</p>
              </div>
            </div>

            {/* Specs */}
            <div className={styles.accordionItem}>
              <button className={styles.accordionBtn} onClick={() => toggleAccordion('specs')}>
                Specifications
                <FontAwesomeIcon icon={isSpecsOpen ? faChevronUp : faChevronDown} />
              </button>
              {/* CHANGED: Check array includes 'specs' */}
              <div className={`${styles.accordionContent} ${isSpecsOpen ? styles.contentActive : ''}`}>
                <table className={styles.specsTable}>
                  <tbody>
                    {product.specifications && Object.entries(product.specifications).map(([k, v]) => (
                      <tr key={k}><th>{k}</th><td>{v}</td></tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Shipping */}
            <div className={styles.accordionItem}>
              <button className={styles.accordionBtn} onClick={() => toggleAccordion('ship')}>
                Shipping & Returns
                <FontAwesomeIcon icon={isShipOpen ? faChevronUp : faChevronDown} />
              </button>
              {/* CHANGED: Check array includes 'ship' */}
              <div className={`${styles.accordionContent} ${isShipOpen ? styles.contentActive : ''}`}>
                <p><strong>Delivery:</strong> {product.shipping?.deliveryTime}</p>
                <p><strong>Return Policy:</strong> {product.returnPolicy}</p>
              </div>
            </div>

          </div>
        </div>

      </div>
      <HomeFooter />
    </div>
  );
};

export default ProductDetail;